import { render, staticRenderFns } from "./addcin.vue?vue&type=template&id=6a8919bc&scoped=true&"
import script from "./addcin.vue?vue&type=script&lang=js&"
export * from "./addcin.vue?vue&type=script&lang=js&"
import style0 from "./addcin.vue?vue&type=style&index=0&id=6a8919bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8919bc",
  null
  
)

export default component.exports